// Поддержка push (нужна для подписки на уведомления — см. pushModule).
export const isPushSupported = () =>
  typeof window !== "undefined" &&
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window

// Поддержка service worker (нужна для PWA: установка, офлайн, кэш).
// Шире, чем push: SW регистрируем даже там, где Push API недоступен.
export const isServiceWorkerSupported = () =>
  typeof window !== "undefined" && "serviceWorker" in navigator

// Было ли действие пользователя на странице. Навигацию SW отдаёт из precache,
// поэтому первое открытие после деплоя всегда рисует старую сборку, а новый SW
// берёт контроль через секунды. Пока пользователь ничего не нажал и не ввёл,
// перезагрузка ничего не теряет — делаем её сразу, а не на уходе со вкладки.
let interacted = false
const markInteracted = () => {
  interacted = true
}
if (typeof window !== "undefined") {
  window.addEventListener("pointerdown", markInteracted, { once: true, capture: true })
  window.addEventListener("keydown", markInteracted, { once: true, capture: true })
}

// Перезагрузка вкладки, когда новая версия SW взяла над ней контроль.
// После действий пользователя откладывается до момента, когда вкладка не на
// экране, — иначе пользователь теряет введённое в открытую форму.
const reloadWhenSafe = () => {
  if (!interacted || document.visibilityState === "hidden") {
    window.location.reload()
    return
  }

  document.addEventListener(
    "visibilitychange",
    () => {
      if (document.visibilityState === "hidden") window.location.reload()
    },
    { once: true }
  )
}

// Подхват новой сборки без ручного сброса кэша.
// SW собран с skipWaiting + clientsClaim: свежая версия сразу берёт под
// контроль открытые вкладки и обновляет precache. Но страница к этому моменту
// уже отрисована старой сборкой — состояние остаётся смешанным до перезагрузки.
const watchForUpdates = (registration) => {
  // Контроллера нет — это первая установка SW на устройстве. clientsClaim
  // тоже поднимет controllerchange, но перезагружать тут нечего.
  if (!navigator.serviceWorker.controller) return

  let reloading = false

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloading) return
    reloading = true
    reloadWhenSafe()
  })

  // Явная проверка обновления: браузер сам делает её не на каждой загрузке.
  registration.update().catch((err) => {
    // eslint-disable-next-line no-console
    console.warn("[pwa] service worker update check failed", err)
  })
}

export const registerServiceWorker = async () => {
  if (!isServiceWorkerSupported()) return null

  try {
    const registration = await navigator.serviceWorker.register("/service-worker.js")
    watchForUpdates(registration)
    return registration
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("[pwa] service worker registration failed", err)
    return null
  }
}
